import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Bubble, NavMenu } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getLocale, useIntl } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import UnloadModal from '@/pages/home/pages/home/Explore/components/UnloadModal';
import { buriedBtnPoint } from '@home/utils/buriedPoint';

function Feedback(props?: any, ref?: any) {
  const { isNoButton } = props;
  const local = getLocale();
  const isEngish = local !== LANGUAGE_CN;
  const [open, setOpen] = useState(false);
  // 切换语言触发组件刷新
  useIntl();

  const handleOnClick = () => {
    buriedBtnPoint({
      buttonId: '100101002',
      extInfo: JSON.stringify({
        feedback: true,
      }),
      pageId: '100101',
      typeId: 'homePage_pc_v2',
    });
    setOpen(true);
  };
  useImperativeHandle(ref, () => ({
    open: handleOnClick, // 暴露 搜索方法
  }));
  return (
    <>
      {!isNoButton && (
        <NavMenu.Item>
          <Bubble
            arrowPointAtCenter
            placement="bottom"
            dark
            placementOffset={20}
            content={!isEngish ? '反馈' : 'Feedback'}
            overlayClassName="dba-nav-menu-overlay"
          >
            <div className="lay-nav-right" onClick={handleOnClick}>
              <SvgIcon className="item-icon" type={'feedback-entrance'} style={{ width: '18px', height: '18px' }} />
            </div>
          </Bubble>
        </NavMenu.Item>
      )}

      <UnloadModal
        visible={open}
        close={() => {
          setOpen(!open);
        }}
      />
    </>
  );
}

export default forwardRef(Feedback);